import React from "react";
import { Instagram } from "lucide-react";
import { CONTACTS } from "@/lib/api";

const WhatsIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51l-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
  </svg>
);

export default function Footer() {
  return (
    <footer id="contatos" className="reveal mx-auto w-full max-w-3xl px-5 pb-12 pt-12 text-center" data-testid="footer">
      <h2 className="font-display text-3xl font-bold tracking-tight text-slate-800 sm:text-4xl">
        Contatos para dúvidas
      </h2>

      {/* WhatsApp pills */}
      <div className="mt-8 flex flex-wrap items-center justify-center gap-4">
        <a
          href={CONTACTS.felipe.url}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-whatsapp-felipe"
          className="group inline-flex items-center gap-4 rounded-full bg-[#EAF5EE] px-7 py-4 transition-all hover:bg-[#d9eee1] hover:shadow-sm"
        >
          <WhatsIcon className="h-7 w-7 text-[#1FA855]" />
          <span className="h-6 w-px bg-slate-300/70" />
          <span className="text-lg font-semibold text-slate-700">{CONTACTS.felipe.name}</span>
        </a>
        <a
          href={CONTACTS.villalobos.url}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-whatsapp-villalobos"
          className="group inline-flex items-center gap-4 rounded-full bg-[#EAF5EE] px-7 py-4 transition-all hover:bg-[#d9eee1] hover:shadow-sm"
        >
          <WhatsIcon className="h-7 w-7 text-[#1FA855]" />
          <span className="h-6 w-px bg-slate-300/70" />
          <span className="text-lg font-semibold text-slate-700">{CONTACTS.villalobos.name}</span>
        </a>
      </div>

      {/* Instagram */}
      <div className="mt-8 flex justify-center">
        <a
          href={CONTACTS.instagram.url}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-instagram"
          className="group inline-flex items-center gap-3 rounded-full px-4 py-2 transition-colors hover:bg-slate-100"
        >
          <Instagram className="h-6 w-6 text-slate-500" />
          <span className="h-5 w-px bg-slate-300" />
          <span className="text-lg font-medium text-slate-500 group-hover:text-slate-700">
            {CONTACTS.instagram.handle}
          </span>
        </a>
      </div>

      <div className="mt-10 border-t border-slate-200 pt-6">
        <p className="text-sm text-slate-400">
          © {new Date().getFullYear()} Reservas Dubal Esportes
        </p>
      </div>
    </footer>
  );
}
